var map = {
	"./1.png": 85773,
	"./1_Click_on_following_link_in_Email.png": 72160,
	"./2.png": 95094,
	"./2_Click_On_SIA_Setupad_Parent_Publisher.png": 10850,
	"./3.png": 73183,
	"./3_Click_Accept.png": 2863,
	"./4.png": 14528,
	"./4_Approved.png": 73140,
	"./5.png": 69353,
	"./6.png": 4210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17020;